import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  VStack,
  HStack,
  Select,
} from "@chakra-ui/react";
import { useState } from "react";
import { db, collection, addDoc } from "../firebase";

const TestimonialUpload = ({ isOpen, onClose, fetchTestimonials }) => {
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");

  const handleSubmit = async () => {
    if (!name || !location || !comment) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      await addDoc(collection(db, "testimonials"), {
        name,
        location,
        rating,
        comment,
      });

      alert("Testimonial added successfully!");
      fetchTestimonials();
      setName("");
      setLocation("");
      setRating(5);
      setComment("");
      onClose();
    } catch (error) {
      console.error("Error adding testimonial:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Testimonial</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <Input
              placeholder="Customer Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <Input
              placeholder="Location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
            <Select
              placeholder="Select Rating"
              value={rating}
              onChange={(e) => setRating(Number(e.target.value))}
            >
              <option value="5">⭐⭐⭐⭐⭐</option>
              <option value="4">⭐⭐⭐⭐</option>
              <option value="3">⭐⭐⭐</option>
              <option value="2">⭐⭐</option>
              <option value="1">⭐</option>
            </Select>
            <Textarea
              placeholder="Customer Review"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={handleSubmit}>
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TestimonialUpload;
